import { render, staticRenderFns } from "./GuideRoot.vue?vue&type=template&id=436849c3"
import script from "./GuideRoot.vue?vue&type=script&lang=js"
export * from "./GuideRoot.vue?vue&type=script&lang=js"
import style0 from "./GuideRoot.vue?vue&type=style&index=0&id=436849c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports